import * as z from "zod"
const SearchResponse = z.object(
  {
    hits: z.array(z.looseObject({})),
    total: z.number(),
    facets: z.record(
      z.string(),
      z.array(
        z.object(
          {
            name: z.string(),
            count: z.number(),
          },
          "invalid facet bucket",
        ),
      ),
    ),
  },
  "invalid search response",
)

export default SearchResponse
export type SearchResponse = z.infer<typeof SearchResponse>
